import { EndpointSetting } from "@/constants/app/type";
import { UserState } from "../type";
import { setLocalStorage } from "@/utils/app/storage";

export const callbackProfile: EndpointSetting['caller'] = (
  state: UserState,
  action: any,
  endpointName: any
) => {
  state.profile.loading = false
  state.profile.error = null
  state.profile.success = true
  state.profile.data = action.payload

  setLocalStorage("user", action.payload); // Save user data to localStorage
}